import { z, isoZ } from 'my-zod'

export const gearListModel = z.object({
  id: z.number(),
  name: z.string().nonempty(),
  productType: z.enum(['OffRoad', 'OnRoad', 'Water', 'Snow']),
  operatorIds: z.number().array(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type gearListModel = z.infer<typeof gearListModel>
